import * as Sentry from '@sentry/nextjs';

import { Locale } from '@kamernet/core/Intl/types';

export { reportError } from './reportError';

export function setUserContextForErrorReporting(
  userEmail: string | undefined,
  locale: Locale,
  anonymousId: string | undefined,
) {
  Sentry.setUser({
    email: userEmail?.toString(),
    locale,
    anonymousId,
  });
}
export function setCustomErrorTag(tagName: string, value: string) {
  Sentry.setTag(tagName, value);
}
